<template>
      <!--====== APPIE HERO PART START ======-->
    
    <section class="appie-hero-area appie-hero-6-area appie-hero-7-area">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-7">
                    <div class="appie-hero-content appie-hero-content-6 appie-hero-content-7">
                        <h1 class="appie-title">TroFii <br/> The Foodie App</h1>
                        <p>2022 Trending App by Foodies in United States. </p>
                        <ul>
                            <li><a target="_blank" href="https://apps.apple.com/us/app/id1424083655"><i class="fab fa-apple"></i> <span>Available on the <span>App Store</span></span></a></li>
                            <li><a target="_blank" class="item-2" href="https://play.google.com/store/apps/details?id=com.www.worests"><i class="fab fa-google-play"></i> <span>Available on the <span>Google Play</span></span></a></li>
                        </ul>
                        <div class="info"> 
                            
                        </div>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="appie-hero-thumb-6">
                        <div class="thumb wow animated fadeInUp text-center" data-wow-duration="1000ms" data-wow-delay="600ms">
                            <img src="@/assets/images/312x630.png" alt="">
                            <div class="back-image">
                                <img src="@/assets/images/hero-shape-2.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <!--====== APPIE HERO PART ENDS ======-->
</template>

<script>
export default {

}
</script>

<style>

</style>